import { ApplicationForm } from '@lendica/application-form';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from './Layout';
import { env } from './api/axiosInstance';
import { useLeadData } from '@lendica/application-form';
import { getCompanyDetails } from '@lendica/api';
import { CompanyStatus } from '@lendica/utils';

export const AppContainer = () => {
    const navigate = useNavigate();
    const { leadData, consumeLeadData } = useLeadData();
    const [initialized, setInitialized] = useState(false);
    const [shouldRenderForm, setShouldRenderForm] = useState(false);

    const onComplete = status => {
        navigate(`../submitted/create`);
    };

    useEffect(() => {
        (async () => {
            try {
                const companyDetails = await getCompanyDetails();
                if (companyDetails?.status === CompanyStatus.Lead) {
                    setShouldRenderForm(true);
                } else {
                    navigate(`/submitted`);
                }
            } catch {
            } finally {
                setInitialized(true);
            }
        })();
    }, []);

    return (
        <Layout loading={!initialized || !shouldRenderForm}>
            <ApplicationForm
                onComplete={onComplete}
                env={env}
                leadData={leadData}
                consumeLeadData={consumeLeadData}
                enableConsentCheck={false} // Set to false to disable consent checking
            />
        </Layout>
    );
};
